import { useState, useEffect } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as actions from '@actions'
import * as store from '@store'
import useAbortableFetch from '@/hook/useAbortableFetch'
import { toast } from 'react-toastify'

import CheckRevenueTable from '../CheckRevenueTable'
import CheckDetailsProduction from '../CheckDetails/CheckDetailsProduction'
import CheckDateRangeFilter from '../CheckDateRangeFilter'

import './Portfolio.css'

const itemsPerPage = 10

const Portfolio = () => {
    
    const [checks, setChecks] = useState(null)
    const [checkProductions, setCheckProductions] = useState(null)
    const [checkRevenue, setCheckRevenue] = useState(null)
    const [pageIndex, setPageIndex] = useState(0)
    const [dateRangeFilter, setDateRangeFilter] = useState({})
    const [loading, setLoading] = useState(false)
    const currentOrganization = useWireValue(store.currentOrganization)
    
    // whenever changing org i have to reset all variables
    useEffect(() => {
        setDateRangeFilter({})
        setPageIndex(0)
        setChecks(null)
        setCheckProductions(null)
        setCheckRevenue(null)
    }, [currentOrganization])
    
    // whenever filtering date i need to clear page index only
    useEffect(() => {
        setPageIndex(0)
    }, [dateRangeFilter])
    
    // i need to fetch revenue upon new org or any new date filter
    useAbortableFetch(() => {
        setLoading(true)
        actions.fetchCheckDetailsRevenue('', undefined, dateRangeFilter)
            .then(it => setCheckRevenue(it))
            .catch(e => {
                console.error(e)
                toast.error('Failed to fetch operator revenue')
            })
        setLoading(false)
    }, [currentOrganization, dateRangeFilter])
    
    // i need to fetch monthly details upon new org, page change or any new date filter
    useAbortableFetch(() => {
        setLoading(true)
        actions.fetchCheckDetailsMonthly('', undefined, {
            offset: (pageIndex * itemsPerPage),
            limit: itemsPerPage,
            ...dateRangeFilter,
        })
            .then(it => setChecks(it))
            .catch(e => {
                console.error(e)
                toast.error('Failed to fetch operator details')
            })
        setLoading(false)
    }, [currentOrganization, pageIndex, dateRangeFilter])
    
    // i need to fetch production upon new org or any new date filter
    useAbortableFetch(() => {
        setLoading(true)        
        actions.fetchCheckProductionByOrgId(dateRangeFilter)
            .then(it => setCheckProductions(it))
            .catch(e => {
                console.error(e)
                toast.error('Failed to fetch operator production')
            })
        setLoading(false)
    }, [currentOrganization, dateRangeFilter])
    
    return (
        
        <div className="Portfolio">
            {loading && !checks?.rows?.length && (
                <CircleSpinner className="absolute-centered" />
            )}
            {currentOrganization && <>
                {!loading && 
                <CheckDateRangeFilter setDateRangeFilter={setDateRangeFilter} resetOn={[currentOrganization]} />
                }
                <h4 className="mt-4 text-xl">Revenue</h4>
                {!loading && <CheckRevenueTable
                    className="mt-4"
                    rows={checks?.rows}
                    checkRevenue={checkRevenue}
                    pageCount={checks?.count || 0}
                    itemsPerPage={itemsPerPage}
                    setPageIndex={setPageIndex} />
                }
                <h4 className="text-xl">Production</h4>
                {!loading && <CheckDetailsProduction checkProduction={checkProductions} />}
            </>}
            {/* <div><pre><code className="text-white">
                {JSON.stringify(checks, null, 4)}
            </code></pre></div> */}
        
        </div>
        
    )
    
}

export default Portfolio
